import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  getTemplatesData,
  addTemplateData,
  setIsConsultationLoading,
  setTemplatesData,
  getEmailsAndSmsTemplatesData,
  setIsTemplatesLoading,
  addEmailsAndSmsTemplatesData,
  setTemplateMessageTypeData,
  setUpdateMessagetemplateData,
  updateEmailsAndSmsTemplatesData,
  getDefaultTemplatesData,
  setEmailSubjectData,
  deleteEmailsAndSmsTemplatesData,
  generatePatientPrescriptionData,
  saveAiTemplateData,
  generateAiTemplateData,
  setAitemplateData,
  updateAiTemplatesData,
  getAiTemplateByCompanyIdData,
  getAiTemplateByIdData,
  sendAiConsultationData,
  setSelectedTemplateData,
  setAiqaData,
  setSelectedTemplateContentData,
  setFullTranscriptData,
  setConsultationInitiatedOnData,
  setHydratedTemplateSectionsData,
  setIsTemplateSelectedData,
  setIsAIQALoadingData,
  deleteAiTemplateByIdData,
  setStreamedTextData,
  getPreConsultTemplateByCompanyIdData,
  savePreConsultTemplateData,
  updatePreConsultTemplatesData,
  deletePreConsultTemplateByIdData,
  generatePreConsultAiTemplateData,
  setIsConsultationSummaryLoadingData,
  setConsultationStreamedSummaryData,
  getDefaultMessageTemplateData,
  setTranscriptionStateData,
} from "../features/templateSlice/templateSlice";

const reducerName = "template";

// #region State Setters
export const setConsultationLoading = (isLoading) => {
  dispatch(setIsConsultationLoading(isLoading));
};

export const setTemplatesLoading = (isLoading) => {
  dispatch(setIsTemplatesLoading(isLoading));
};

export const setConsultation = (newTemplates) => {
  dispatch(setTemplatesData(newTemplates));
};

export const setTemplateMessageType = (type) => {
  dispatch(setTemplateMessageTypeData(type));
};

export const setUpdateMessagetemplate = (data) => {
  dispatch(setUpdateMessagetemplateData(data));
};

export const setEmailSubject = (data) => {
  dispatch(setEmailSubjectData(data));
};
export const setAiTemplate = (data) => {
  dispatch(setAitemplateData(data));
};

export const setSelectedTemplate = (data) => {
  dispatch(setSelectedTemplateData(data));
};
export const setSelectedTemplateContent = (data) => {
  dispatch(setSelectedTemplateContentData(data));
};

export const setAiqa = (data) => {
  dispatch(setAiqaData(data));
};

export const setFullTranscript = (data) => {
  dispatch(setFullTranscriptData(data));
};

export const setConsultationInitiatedOn = (data) => {
  dispatch(setConsultationInitiatedOnData(data));
};
export const setIsTemplateSelected = (data) => {
  dispatch(setIsTemplateSelectedData(data));
};
export const setIsAIQALoading = (data) => {
  dispatch(setIsAIQALoadingData(data));
};
export const setStreamedText = (data) => {
  dispatch(setStreamedTextData(data));
};
export const setHydratedTemplateSections = (data) => {
  dispatch(setHydratedTemplateSectionsData(data));
};
export const setIsConsultationSummaryLoading = (data) => {
  dispatch(setIsConsultationSummaryLoadingData(data));
};
export const setConsultationStreamedSummary = (data) => {
  dispatch(setConsultationStreamedSummaryData(data));
};
export const setTranscriptionState = (data) => {
  dispatch(setTranscriptionStateData(data));
};

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getAllTemplates = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getTemplatesData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};
export const addTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(addTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const getEmailsAndSmsTemplates = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getEmailsAndSmsTemplatesData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

export const addEmailsAndSmsTemplates = async (data) => {
  let result = null;
  try {
    result = await dispatch(addEmailsAndSmsTemplatesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const updateEmailsAndSmsTemplates = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateEmailsAndSmsTemplatesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getDefaultTemplates = async (actionType) => {
  let result = null;
  try {
    result = await dispatch(getDefaultTemplatesData(actionType)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, actionType);
    result = null;
  }
  return result;
};

export const deleteTemplates = async (templateIds) => {
  let result = false;
  try {
    result = await dispatch(
      deleteEmailsAndSmsTemplatesData(templateIds),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, templateIds);

    result = false;
  }
  return result;
};

export const generatePatientPrescription = async (data) => {
  let result = null;
  try {
    result = await dispatch(generatePatientPrescriptionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const generateAiTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(generateAiTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const saveAiTemplate = async (params) => {
  let result = null;

  try {
    result = await dispatch(saveAiTemplateData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const getAiTemplateByCompanyId = async (params) => {
  let result = null;

  try {
    result = await dispatch(getAiTemplateByCompanyIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const updateAiTemplates = async (params) => {
  let result = null;

  try {
    result = await dispatch(updateAiTemplatesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};
export const getAiTemplateById = async (templateId) => {
  let result = [];
  try {
    result = await dispatch(getAiTemplateByIdData(templateId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, templateId);

    throw error;
  }
  return result;
};

export const sendAIQAService = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendAiConsultationData({ data })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const deleteAiTemplateById = async (templateID) => {
  let result = null;
  try {
    result = await dispatch(deleteAiTemplateByIdData(templateID)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, templateID);
    result = null;
  }
  return result;
};
export const getPreConsultTemplateByCompanyId = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      getPreConsultTemplateByCompanyIdData(params),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const savePreConsultTemplates = async (params) => {
  let result = null;
  try {
    result = await dispatch(savePreConsultTemplateData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const updatePreConsultTemplates = async (params) => {
  let result = null;
  try {
    result = await dispatch(updatePreConsultTemplatesData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deletePreConsultTemplateById = async (params) => {
  let result = null;
  try {
    result = await dispatch(deletePreConsultTemplateByIdData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const generatePreConsultAiTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(generatePreConsultAiTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
export const getDefaultMessageTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(getDefaultMessageTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};
// #endregion
